export default __webpack_public_path__ + "static/media/a008-1.33f027a1.svg";